import React, { Component } from "react";
import BASE_URL from "../../config";

export default class Team extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      role: "",
      phone: "",
      photo: null,
      team: []
    };
  }

  componentDidMount() {
    this.getTeam();
  }

  // 📌 Fetch team data
  getTeam = () => {
   fetch(`${BASE_URL}/api/getTeam.php`)
      .then(res => res.json())
      .then(data => this.setState({ team: data }))
      .catch(err => console.error("Fetch error:", err));
  };

  // 📌 Handle input
  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  // 📌 Handle file
  handleFile = (e) => {
    this.setState({ photo: e.target.files[0] });
  };

  // 📌 Submit form
  handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("name", this.state.name);
    formData.append("role", this.state.role);
    formData.append("phone", this.state.phone);
    formData.append("photo", this.state.photo);

   fetch(`${BASE_URL}/api/addTeam.php`, {
      method: "POST",
      body: formData
    })
      .then(res => res.text())
      .then(data => {
        alert(data);
        this.getTeam(); // refresh table
      })
      .catch(err => console.error(err));
  };
handleDelete = (id) => {
  if (!window.confirm("Are you sure you want to delete?")) return;

  const formData = new FormData();
  formData.append("id", id);

 fetch(`${BASE_URL}/api/deleteTeam.php`, {
    method: "POST",
    body: formData
  })
    .then(res => res.text())
    .then(data => {
      alert(data);
      this.getTeam(); // refresh list
    })
    .catch(err => console.error(err));
};
  render() {
    return (
      <div className="team-page">

        {/* FORM */}
        <div className="form-container">
          <h2>સભ્ય સંપાદિત કરો</h2>

          <form onSubmit={this.handleSubmit} className="form">

            <label>નામ</label>
            <input
              type="text"
              name="name"
              placeholder="નામ"
              onChange={this.handleChange}
              required
            />

            <label>રોલ</label>
            <input
              type="text"
              name="role"
              placeholder="રોલ"
              onChange={this.handleChange}
              required
            />

            <label>ફોન નંબર</label>
            <input
              type="tel"
              name="phone"
              placeholder="ફોન નંબર"
              onChange={this.handleChange}
              required
            />

            <label>ફોટો</label>
            <input type="file" onChange={this.handleFile} />

            <button type="submit">Add</button>
          </form>
        </div>

        {/* TABLE */}
        <div className="table-container">
          <table className="team-table">
            <thead>
              <tr>
                <th>#</th>
                <th>ફોટો</th>
                <th>નામ</th>
                <th>રોલ</th>
                <th>ફોન નંબર</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {this.state.team.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>
                    <img
                      src={`${BASE_URL}/uploads/${item.photo}`}
                      width="200"
                      height="200"
                      alt=""
                    />
                  </td>
                  <td>{item.name}</td>
                  <td>{item.role}</td>
                  <td>{item.phone}</td>
                   <td>
        <button
          onClick={() => this.handleDelete(item.id)}
          style={{
            background: "#b41212",
            color: "#fff",
            border: "none",
            padding: "5px 0px",
            cursor: "pointer",
            width:"100px"
          }}
        >
          Delete
        </button>
      </td>
                </tr>
              ))}
            </tbody>

          </table>
        </div>

      </div>
    );
  }
}